export function rebuildSwitchElement(switchElement) {
  const switchDiv = switchElement.closest('.switch')
  const switchDivContent = switchDiv.html()

  switchDiv.html(switchDivContent)
}